import React, { useEffect, useState } from 'react';
import { useReducedMotion } from 'framer-motion';
interface FlickerGridProps {
  cols?: number;
  rows?: number;
}
export function FlickerGrid({
  cols = 18,
  rows = 8
}: FlickerGridProps) {
  const reduce = useReducedMotion();
  const total = cols * rows;
  const [lit, setLit] = useState<Map<number, 'ember' | 'white'>>(new Map());
  useEffect(() => {
    if (reduce) return;
    const id = window.setInterval(() => {
      const next = new Map<number, 'ember' | 'white'>();
      const n = 6 + Math.floor(Math.random() * 6);
      for (let k = 0; k < n; k++) {
        next.set(Math.floor(Math.random() * total), Math.random() > 0.6 ? 'ember' : 'white');
      }
      setLit(next);
    }, 700);
    return () => window.clearInterval(id);
  }, [reduce, total]);
  return <div aria-hidden className="pointer-events-none absolute inset-0 grid" style={{
    gridTemplateColumns: `repeat(${cols}, 1fr)`,
    gridTemplateRows: `repeat(${rows}, 1fr)`
  }} data-id="element-343" data-mp="3dhtbz841uw7e">
      {Array.from({
      length: total
    }).map((_, i) => {
      const tone = lit.get(i);
      return <div key={i} className={`border-b border-r border-white/[0.04] transition-[background-color] duration-200 ease-out ${tone === 'ember' ? 'bg-ember/70' : tone === 'white' ? 'bg-white/[0.07]' : 'bg-transparent'}`} data-id="element-344" data-mp="3trmhi466idu6" data-mpi={i} />;
    })}
    </div>;
}